import React, { useState ,useEffect } from 'react';
import { Input, Button, Table, Select, Spin } from 'antd';
import { AiFillAccountBook } from 'react-icons/ai';
import { toast } from 'react-toastify';
import AdminNavbar from '../Navbar/AdminNavbar'
import TextArea from 'antd/es/input/TextArea';
import { Option } from 'antd/es/mentions';
import { UserMasterAdd, UserMasterBlock, UserMasterGetAll, UserMasterUpdate } from '../Api/All_Api';
import axios from 'axios';
import { Tooltip } from 'antd'; 
import { useNavigate } from 'react-router-dom';
import TitleNavbar from '../Navbar/TitleNavbar';

const UserMaster = () => {

  const branchId = sessionStorage.getItem('branchId');
  const role = sessionStorage.getItem('role');

   const sessionYear = sessionStorage.getItem('sessionYear');
 const navigate = useNavigate();
     useEffect(() => {
       if (!sessionYear) {
         sessionStorage.clear();
         navigate('/')
       }
     },[])

  const [userName, setUserName] = useState('');
  const [allUsers, setAllUsers] = useState([]);
 
  const [mobileNumber, setMobileNumber] = useState('');


  const [errors, setErrors] = useState({
    userName: '',
    address: '',
    mobileNumber: '',
    loginId:'',
    password:'',
  });

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const[loginId,setLoginId]=useState('');
  const[password,setPassword]=useState('');
  const[userId,setUserId]=useState('');
  const [updateButton, setUpdateButton] = useState(false);
    const [saveButton, setSaveButton] = useState(true);
    const [loading, setLoading] = useState(false);
    useEffect(() => {
      fetchUsers();
    }, []);
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${UserMasterGetAll}?bid=${branchId}`);
        if (response.data) {
          setAllUsers(response.data);
          setFilteredData(response.data);
          setTotalEntries(response.data.length);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
        toast.error('Failed to fetch user data');
      }
    };
  const handleSearch = (value) => {
    const filtered = allUsers.filter((item) =>
      Object.values(item).some((val) =>
        val?.toString().toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };
  const handleCancel = () => {
    setUpdateButton(false);
    setSaveButton(true);
    setUserName('');
   
    setMobileNumber('');
    setLoginId('');
    fetchUsers();
    setErrors({});
  };

  const handleSubmit = async() => {
    let isValid = true;
    const errorObj = {};

    if (!userName) {
      isValid = false;
      errorObj.userName = " Name is required *";
    }
   
    if (!loginId) {
      isValid = false;
      errorObj.loginId = "LoginId is required *";
    }
    // if (!password) {
    //   isValid = false;
    //   errorObj.password = "password is required *";
    // }
    if (!mobileNumber) {
      isValid = false;
      errorObj.mobileNumber = "Mobile number is required *";
    }

    setErrors(errorObj);

    if (!isValid) return;
    setLoading(true);

    const bodyData = {
      name: userName,
      mobileNo:mobileNumber ,
      loginId: loginId,
      branchId:branchId,
      
    };

    try {
      const response = await axios.post(UserMasterAdd, bodyData);
      if (response.data === "SAVED") {
        toast.success('User added successfully!');
        fetchUsers();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn('User already exists!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSaveButton(false);
    setUserName(item.name);
    setUserId(item.id);
    setMobileNumber(item.mobileNo);
    setLoginId(item.loginId);
  
  };


  const handleUpdate = async() => {
    let isValid = true;
    const errorObj = {};

    if (!userName) {
      isValid = false;
      errorObj.customerName = " Name is required *";
    }
   
    if (!loginId) {
      isValid = false;
      errorObj.address = "LoginId is required *";
    }
    
    if (!mobileNumber) {
      isValid = false;
      errorObj.mobileNumber = "Mobile number is required *";
    }

    setErrors(errorObj);

    if (!isValid) return;

    setLoading(true);
    const bodyData = {
      id:userId,
      name: userName,
      mobileNo:mobileNumber ,
      loginId: loginId,
     
  
    };

    try {
      const response = await axios.put(UserMasterUpdate, bodyData);
      if (response.data === "UPDATED") {
        toast.success('User updated successfully!');
        fetchUsers();
        handleCancel();
      } else if (response.data === "ALREADYEXISTS") {
        toast.warn('User already exists!');
        handleCancel();
      }
    } catch (error) {
      console.error('Error during API call:', error);
      toast.error('Error occurred while submitting data');
    }
    finally{
      setLoading(false);
    }
  };
  const toggleBlockStatus = async (item) => {
    const confirmDelete = window.confirm(`Are you sure you want to  ${item.userStatus === 1 ? 'unblock' : 'block'} ${item.name}?`);
    if (!confirmDelete) return;
    try {
     
      const updatedActiveStatus = item.userStatus === 0 ? 1 : 0;  // If isActive is 0, change to 1 (active); if 1, change to 0 (inactive)
      
   
      const response = await axios.put(`${UserMasterBlock}?id=${item.id}&status=${updatedActiveStatus}` );
  
      if (response.data === "UPDATED") {
      
        setAllUsers(
          allUsers.map((c) =>
            c.id === item.id ? { ...c, userStatus: updatedActiveStatus } : c
          )
        );
  
        fetchUsers();
        toast.success(`User ${updatedActiveStatus === 1 ? 'blocked' : 'unblocked'} successfully!`);
      } else {
        
        toast.error('Failed to update active status.');
      }
    } catch (error) {
      // Catch errors and display a toast message
      toast.error('Error updating active status!');
      console.error('Axios error:', error);
    }
  };

  const columns = [
    {
      title: 'Sr.No.',
      dataIndex: '',
      key: 'index',
      render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'useerName',
    },
{
      title: 'Mobile Number',
      dataIndex: 'mobileNo',
      key: 'mobileNo',
    },
    {
      title: 'Login Id',
      dataIndex: 'loginId',
      key: 'loginId',
    },
    {
      title: "Status",
      dataIndex: "userStatus",
      key: "userStatus",
      key: "userStatus",
      render: (text) => (
       <span
       style={{
         display: "inline-block",
         padding: "2px 10px",
         justifyItems:"center",
         color: "white",
         borderRadius: "4px",
         backgroundColor: text == "1" ? "red" : "green",
       }}
     >
       {text == "1" ? "Blocked" : "Active"}
     </span>
      ),
    },
    {
      title: "Edit",
      key: "edit",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
          <span
           className='me-1 me-lg-2'
            type="submit"
            style={{ fontSize: "12px", color: "orange" }}
            onClick={() => handleEditDataButton(record)}
          >
           <Tooltip title="Edit"> <i className="fa-solid fa-pen-to-square"></i></Tooltip>
          </span>
          
      
        </div>
      ),
    },
    {
      title: "Block",
      key: "block",
      width:"60px",
      render: (text, record) => (
        <div className='text-center'>
          
          <span
           className='me-1 me-lg-2'
          type="button"
          style={{
            fontSize: "12px", 
            color: record.userStatus === 1 ? "red" : "green", 
           
            cursor: "pointer"
          }}
          onClick={() => toggleBlockStatus(record)} 
        >
        <Tooltip title={record.userStatus === 0 ? "Blocked":"Active" }>  <i className={`fa-solid ${record.userStatus === 1 ? 'fa-lock' : 'fa-unlock'}`}></i> </Tooltip>
        </span>
      
        </div>
      ),
    },
   
      
  ];
  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th {...restProps} style={{ backgroundColor: "#000", color: "#fff", padding: "10px", fontSize: "13px", borderRadius: "0px" }}>
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr {...restProps} style={{ backgroundColor: "#f0f7fd" }}>
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td {...restProps} style={{ padding: "8px" }}>
          {children}
        </td>
      ),
    },
  };
  const validateMobileNumber = (value) => {
    // Check if the entered value contains non-digit characters
    if (/[^0-9]/.test(value)) {
      setErrors({
        ...errors,
        mobileNumber: 'Mobile number should contain only digits.',
      });
    } else {
      setErrors({
        ...errors,
        mobileNumber: '', // Clear error if valid
      });
    }

    // Set the mobile number value
    setMobileNumber(value);
  };

    //===================================
const navbg = {
  backgroundColor:"#f79400",
  boxShadow: "0 2px 4px -2px rgba(0,0,0,.5)",
  display: "flex",
  alignItems: "center",
  padding: "5px 10px",
  fontSize: "19px",
  color:"#fff"
}
//=====================================================


  return (
    <>
   <AdminNavbar />

      <div className="p-0 m-0">

        <div
          className="row m-0"
          style={navbg}
        >
          <div
            className="col-12"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            
            <span className="px-md-5" style={{ flexGrow: 1 }}>
      <AiFillAccountBook  />&nbsp;
     User Master
    </span>

    {/* TitleNavbar (Right-aligned) */}
    <span>
      <TitleNavbar />
    </span>
          </div>
        </div>

        {/* Form Section */}
      
        <div className='row m-0 p-0 pt-5'>
          <div className='col-12 col-lg-3'></div>
          <div className='col-12 col-lg-6'>
              <div className="row px-md-5 mt-3  m-0">

      {/* Name Field */}
      <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
            <label className="labels" style={{fontSize:16}}>Name:</label>
          </div>
          <div className="col-9 col-lg-6" >
            <Input
              placeholder="Enter  Name"
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
            {errors.userName && (
              <div className="errorField">{errors.userName}</div>
            )}
          </div>
        </div>
      </div>

      {/* Mobile Number Field */}
      <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Mobile No.:</label>
          </div>
          <div className="col-9 col-lg-6">
            <Input
              placeholder="Enter Mobile No."
              maxLength="13"
              value={mobileNumber}
              onChange={(e) => validateMobileNumber(e.target.value)} 
              type="tel"
            />
            {errors.mobileNumber && (
              <div className="errorField">{errors.mobileNumber}</div>
            )}
          </div>
        </div>
      </div>

      {/* Login Id Field */}
      <div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Login Id:</label>
          </div>
          <div className="col-9 col-lg-6">
            <Input
              placeholder="Enter Login Id"
           
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
            />
            {errors.loginId && (
              <div className="errorField">{errors.loginId}</div>
            )}
          </div>
        </div>
      </div>

      {/* Password Field
      {!updateButton &&(<div className="col-12 pt-2">
        <div className="row m-0">
          <div className="col-3 p-0 lableStyle">
            <label className="labels"  style={{fontSize:16}}>Password:</label>
          </div>
          <div className="col-9">
            <Input
              placeholder="Enter Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            {errors.password && (
              <div className="errorField">{errors.password}</div>
            )}
          </div>
        </div>
    
</div>)} */}
    </div>

          <div className="col-12 text-center pt-3">
            <Button
              type="button"
              onClick={handleCancel}
              className="CancelBtn mx-1"
             
            >
              Cancel
            </Button>
           {saveButton &&( <Button
              type="button"
              className="SubmitBtn mx-1"
           
              onClick={handleSubmit}
              disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Save'}
            </Button>)}
          {updateButton &&( <Button
              type="button"
              className="SubmitBtn mx-1"
             
              onClick={handleUpdate}
              disabled={loading} // Disable button while loading
      >
        {loading ? <Spin size="small" /> : 'Update'}
            </Button>)} 
          </div>

          <div
            className="col-12 p-0 mt-3"
            style={{ borderBottom: '2px solid #bfb597' }}
          ></div>
  </div>
  </div>
        <div className='col-12 col-md-2 col-lg-4'></div>
        </div>

     {/* Table Section */}
           <div className="row m-0 p-2 mb-5 pt-md-0 mt-3">
             <div className="col-12 col-md-2"></div>
             <div className="col-12 col-md-8 py-3 shadow border" style={{ marginBottom: "50px", backgroundColor: "white" }}>
               <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
                 <div>
                   <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
                   <Select
                     defaultValue={pageSize}
                     onChange={handlePageSizeChange}
                     style={{ width: 120, textAlign: "center" }}
                   >
                     <Option value={10}>10</Option>
                     <Option value={20}>20</Option>
                     <Option value={30}>30</Option>
                   </Select>
                 </div>
   
                 <div className="pt-4 pt-md-0">
                   <Input.Search placeholder="Search" onSearch={handleSearch} style={{ width: 200, marginBottom: 16 }} />
                 </div>
               </div>
   
               <div style={{ backgroundColor: "white" }}>
                 <Table
                   bordered
                   style={{ padding: "0px 20px", overflowX: "auto" }}
                   columns={columns}
                   dataSource={filteredData}
                   pagination={{
                     pageSize: pageSize,
                     total: totalEntries,
                     showTotal: (total, range) => `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                     current: currentPage,
                     onChange: (page) => setCurrentPage(page),
                   }}
                   showSorterTooltip={false}
                   rowKey={(record) => record.id}
                   components={components}
                 />
               </div>
             </div>
             <div className="col-12 col-md-2"></div>
           </div>
        
 
    </>
  );
};

export default UserMaster;
